export default "__VITE_ASSET__BXyP476a__"